import { render } from "./DocCollectedCard.vue?vue&type=template&id=0405d8af&scoped=true"
import script from "./DocCollectedCard.vue?vue&type=script&lang=js"
export * from "./DocCollectedCard.vue?vue&type=script&lang=js"

import "./DocCollectedCard.vue?vue&type=style&index=0&id=0405d8af&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0405d8af"]])

export default __exports__